module.exports = __webpack_public_path__ + "img/pantalla_ganar.d36f02b7.png";